export default "__VITE_ASSET__BaScgurW__"